import Text from "../../../Components/Text"
import Button from "../../../Components/Buttons/Button";
import { useState } from "react";
import BackButton from "../../../Components/Buttons/Variants/BackButton";
import { getByCode } from "../../../Model/WorkspaceUser";
import Snackbar from "../../../Components/Elements/Snackbar";
export const WorkerLogin = ({ afteraction = null, backButton = true }) => {
    const [inputValue, setInputValue] = useState("")
    const [snackbarMessage, setSnackbarMessage] = useState("");

    async function handleEnterClick() {
        if(inputValue === ""){
            return
        }
        const user = await getByCode(inputValue)
        if(!user){
            setSnackbarMessage("Nutzer mit diesem Code Existiert nicht!")
            setInputValue("")
        } else {
            setInputValue("")
            afteraction(user)
        }
    }

    const inputNumber = (value) => {
        setInputValue((prev) => `${prev || ""}${value}`);
    }

    const numberButton = (number) => (
        <Button text={`${number}`} classNames="text-xl w-full h-full" onClickAction={() => inputNumber(number)} />
    );

    const registerInputTerminal = () => (
        <div className="h-full w-full flex flex-col gap-1">
            <div className="w-full h-full flex flex-row gap-1">
                {numberButton(1)}
                {numberButton(2)}
                {numberButton(3)}
            </div>
            <div className="w-full h-full flex flex-row gap-1">
                {numberButton(4)}
                {numberButton(5)}
                {numberButton(6)}
            </div>
            <div className="w-full h-full flex flex-row gap-1">
                {numberButton(7)}
                {numberButton(8)}
                {numberButton(9)}
            </div>
            <div className="w-full h-full flex flex-row gap-1">
                <Button text={"Enter"} classNames="text-xl w-full py-1" buttonColor="bg-lime-500" onClickAction={() => handleEnterClick()} />
                <Button text={"0"} classNames="text-xl w-full py-1" onClickAction={() => inputNumber(0)} />
                <Button text={"Delete"} classNames="text-xl w-full py-1" buttonColor="bg-red-500" onClickAction={() => setInputValue("")} />
            </div>
        </div>
    );


    return (
    <div className="flex flex-col gap-2 items-center justify-center h-full">
        <div className="flex gap-2 items-center justify-center">
            {backButton && (
                <BackButton/>
            )}
            
            <Text type="maintitle" classNames="text-center">Gib zum Fortfahren bitte deine Mitarbeiterpin an</Text>
        </div>
        
        <div className="h-10 text-center border border-gray-300 w-full rounded-lg bg-gray-100">
            <Text type="itemmain">{inputValue}</Text>
        </div>
        {registerInputTerminal()}
        <Snackbar message={snackbarMessage} onClose={() => setSnackbarMessage("")} />
    </div>)
}